function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { actions as assetViewerActions } from '../../../../reducers/assetViewer.reducer';
import { FaTimes } from 'react-icons/fa';
import AssetThumbnail from '../../../assets/AssetThumbnail.react';
var Assets = function Assets(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'image' : _ref$type,
    onClose = _ref.onClose,
    onSelect = _ref.onSelect;
  var dispatch = useDispatch();
  var index = useSelector(function (s) {
    return s.assetViewer.index;
  });
  var filters = useSelector(function (s) {
    return s.assetViewer.filters;
  });
  var activeApiCalls = useSelector(function (s) {
    return s.app.activeApiCalls;
  });
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    assets = _useState2[0],
    setAssets = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useState5 = useState(filters.searchString),
    _useState6 = _slicedToArray(_useState5, 2),
    query = _useState6[0],
    setQuery = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    page = _useState8[0],
    setPage = _useState8[1];
  useEffect(function () {
    $('body').css({
      overflowY: 'hidden'
    });
    return function () {
      $('body').css({
        overflowY: 'scroll'
      });
    };
  }, []);
  useEffect(function () {
    setIsLoading(activeApiCalls.find(function (x) {
      return x.id === 'asset-viewer-index';
    }) ? true : false);
  }, [activeApiCalls]);
  useEffect(function () {
    dispatch({
      type: assetViewerActions.modal,
      payload: {
        page: page,
        type: type
      }
    });
  }, [page]);
  useEffect(function () {
    setAssets(Object.values(index).filter(function (x) {
      return x.type === type;
    }).sort(function (a, b) {
      return b.dateAdded.localeCompare(a.dateAdded);
    }));
  }, [index]);
  return /*#__PURE__*/React.createElement("div", {
    className: "a-viewer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "a-viewer__close",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(FaTimes, null)), assets.slice(0, (page + 1) * 25).map(function (x) {
    return /*#__PURE__*/React.createElement(AssetThumbnail, _extends({}, x, {
      onClick: function onClick() {
        if (onSelect) onSelect(x);
      },
      key: x._id
    }));
  }), /*#__PURE__*/React.createElement("div", {
    className: "asset-thumb",
    onClick: function onClick() {
      if (!isLoading) setPage(page + 1);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "asset-thumb__img"
  }, isLoading ? 'Loading...' : 'Load More')));
};
export default Assets;